/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_SelectedInputs */

const en_ui_selected = /** @type {(inputs: Ui_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Ui_SelectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ui_selected = /** @type {((inputs: Ui_SelectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_SelectedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ui_selected(inputs)
});